<div class="modal-container">
  <button
    id="modalEjemplo"
    #modalEjemplo
    data-bs-toggle="modal"
    data-bs-target="#modelEje"
    hidden="hidden">
    Launch
  </button>
  <div
    class="modal fade"
    id="modelEje"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title h5-tipografia-govco">Ingrese los datos</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="actor" class="form-label">Actor</label>
            <ng-container *ngIf="actorFlag">
              <select
                [id]="actor"
                class="form-select"
                [formControlName]="actor"
                (change)="onChangeActor($event)">
                <option
                  value="Usuario"
                  [selected]="actor === 'Usuario' || actor === 'Ninguno'">
                  Usuario
                </option>
                <option value="Sistema" [selected]="actor === 'Sistema'">
                  Sistema
                </option>
              </select>
            </ng-container>
            <ng-container *ngIf="!actorFlag">
              <input
                id="actori"
                type="text"
                class="form-control"
                [formControlName]="actor"
                [readonly]="true"
                value="Sistema" />
            </ng-container>
          </div>
          <form [formGroup]="ejemploForm" (ngSubmit)="submitForm()">
            <div class="row">
              <div
                *ngFor="let field of ejemploFieldsForm"
                class="col-md-{{ field.width }}">
                <div class="mb-3">
                  <!-- Textarea -->
                  <textarea
                    *ngIf="field.type === 'textarea'"
                    [id]="field.name"
                    class="form-control"
                    [formControlName]="field.name"
                    rows="3"></textarea>
                  <!-- Validation Error Messages -->
                  <div *ngIf="getErrorMessage(field.name)" class="text-danger">
                    {{ getErrorMessage(field.name) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-3 d-flex gap-2">
              <button type="submit" class="btn-govco fill-btn-govco">
                Guardar
              </button>
              <button
                type="button"
                class="btn-govco btn-govco"
                data-bs-dismiss="modal">
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
